export const Theme = {
  colors: {
    lightBorder: "#E8E8E8"
  },
};

